export enum NodeParamSourceTypes {
  Unknown = 0,
  Null = 1,
  Value = 2,
  Expression = 4,
  Variable = 8,
  NodeEdge = 16,
  WorkflowEdge = 32,
}
